import '@lwc/synthetic-shadow';
import { enableMapSet } from 'immer';
import PageContainer from 'page/rootContainer';
import { IS_DEVELOPMENT, IS_PRODUCTION, NODE_VERSION, VERSION } from './config';
import { getVersion } from './modules/services/versionService';
import { logger } from './modules/utilities/logger';

enableMapSet();

if (IS_DEVELOPMENT) {
    logger.info(
        `Started Mercury v${VERSION}${NODE_VERSION ? `, hosted on Node ${NODE_VERSION}` : ''} (built on ${new Date(
            bundled.env.BUILD_TIMESTAMP
        ).toLocaleString()}) © Copyright ${new Date().getFullYear()} Salesforce, Inc.`
    );

    getVersion()
        .then((version) => logger.info(`Connected to API v${version}`))
        .catch((error) => logger.error('Failed to connect to API: ' + error));

    (async function exposeStoresDuringDevelopment() {
        (window as unknown as AnyObject).stores = {
            listingStore: (await import('~/modules/stores/listings/listingStore')).listingStore,
            publisherStore: (await import('~/modules/stores/publisher/publisherStore')).publisherStore,
            publisherEditorStore: (await import('~/modules/stores/publisher/publisherEditorStore'))
                .publisherEditorStore,
            japanesePublisherEditorStore: (await import('~/modules/stores/publisher/japanesePublisherEditorStore'))
                .japanesePublisherEditorStore,
            listingsStore: (await import('~/modules/stores/listingsStore')).listingsStore,
            routerStore: (await import('~/modules/stores/routerStore')).routerStore
        };
    })();
} else if (IS_PRODUCTION) {
    logger.info(
        `Started Mercury v${VERSION} (built on ${new Date(
            bundled.env.BUILD_TIMESTAMP
        ).toLocaleString()}) © Copyright ${new Date().getFullYear()} Salesforce, Inc.`
    );
}

customElements.define('root-container', PageContainer.CustomElementConstructor);

try {
    // eslint-disable-next-line @lwc/lwc/no-document-query
    const main = document.querySelector('#main') as Element;
    main.appendChild(document.createElement('root-container'));
} catch (error) {
    logger.error(error);
}
